import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Canonical = () => {
  const { pathname } = useLocation();
  // Standardize: No trailing slash unless root
  const normalizedPath =
    pathname.endsWith("/") && pathname !== "/"
      ? pathname.slice(0, -1)
      : pathname;
  const canonicalUrl = `https://www.muskansoftwares.com${normalizedPath}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default Canonical;
